import { useAuth } from "@tellescope/tanstack-query";

const MINUTES_IN_DAY = 24 * 60;

export const useDayBoundsMinutes = () => {
  const { selectedOrganization } = useAuth();
  const dayStart = selectedOrganization?.settings?.calendar?.dayStart;
  const dayEnd = selectedOrganization?.settings?.calendar?.dayEnd;

  const dayStartMinutes = dayStart ? Math.max(0, dayStart.hour * 60 + dayStart.minute) : 0;
  const dayEndMinutesRaw = dayEnd ? dayEnd.hour * 60 + dayEnd.minute : MINUTES_IN_DAY;
  const dayEndMinutes = Math.min(MINUTES_IN_DAY, Math.max(dayStartMinutes + 60, dayEndMinutesRaw));

  return { dayStartMinutes, dayEndMinutes };
};
